import { useState } from 'react';
import ScrollReveal from '@/components/base/ScrollReveal';
import BrokerCard from '@/pages/forex-trading/components/BrokerCard';
import BrokerFilterBar from '@/pages/forex-trading/components/BrokerFilterBar';
import {
  brokerFilter,
  brokers,
  type BrokerCostModel,
  type BrokerPlatformType,
} from '@/mocks/brokers';

export default function BrokerGrid() {
  const [platform, setPlatform] = useState('all');
  const [cost, setCost] = useState('all');

  const visibleBrokers = brokers.filter((broker) => {
    const platformMatch =
      platform === 'all' || broker.platformTypes.includes(platform as BrokerPlatformType);
    const costMatch = cost === 'all' || broker.costModels.includes(cost as BrokerCostModel);
    return platformMatch && costMatch;
  });

  const isCostFocus = cost !== 'all';

  const reset = () => {
    setPlatform('all');
    setCost('all');
  };

  return (
    <div>
      <BrokerFilterBar
        platform={platform}
        cost={cost}
        onPlatform={setPlatform}
        onCost={setCost}
        onReset={reset}
        visibleCount={visibleBrokers.length}
        totalCount={brokers.length}
      />

      {visibleBrokers.length > 0 ? (
        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {visibleBrokers.map((broker, index) => (
            <ScrollReveal key={broker.id} delay={index * 80} className="h-full">
              <BrokerCard broker={broker} highlightCost={isCostFocus} />
            </ScrollReveal>
          ))}
        </div>
      ) : (
        <div className="mt-5 flex flex-col items-start gap-3 rounded-xl border border-dashed border-background-300 bg-background-50 px-5 py-8">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 text-foreground-500">
            <i className="ri-search-eye-line text-lg" />
          </span>
          <div>
            <p className="font-heading text-sm font-semibold text-foreground-950">
              {brokerFilter.emptyTitle}
            </p>
            <p className="mt-1 max-w-xl text-xs leading-relaxed text-foreground-600">
              {brokerFilter.emptyText}
            </p>
          </div>
          <button
            type="button"
            onClick={reset}
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-xs font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-refresh-line text-sm" />
            {brokerFilter.resetLabel}
          </button>
        </div>
      )}
    </div>
  );
}